import {
  LayoutDashboard,
  BookOpen,
  PieChart,
  ShoppingCart,
  Boxes,
  Users,
  User,
  Truck,
  Wallet,
  FileText,
  PackageOpen,
  Package
} from 'lucide-react';

const icons = {
  LayoutDashboard,
  Boxes,
  Users,
  User,
  Truck,
  Wallet,
  FileText,
  PackageOpen,
  Package,
  ShoppingCart,
  BookOpen,
  PieChart
};

import { getUserData } from '../utils/authUtils';

const userData = getUserData();

const commonItems = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'item',
    url: '/dashboard/default',
    icon: icons.LayoutDashboard,
    breadcrumbs: false
  },
  {
    id: 'assets',
    title: 'Assets',
    type: 'item',
    url: '/assets',
    icon: icons.PackageOpen,
    breadcrumbs: false
  },
  {
    id: 'stocks',
    title: 'Stocks',
    type: 'item',
    url: '/stocks',
    icon: icons.Package,
    breadcrumbs: false
  },
  {
    id: 'party',
    title: 'Party',
    type: 'collapse',
    icon: icons.Users,
    breadcrumbs: false,
    children: [
      {
        id: 'customer',
        title: 'Customer',
        type: 'item',
        url: '/customer',
        icon: icons.User,
        breadcrumbs: false
      },
      {
        id: 'supplier',
        title: 'Supplier',
        type: 'item',
        url: '/supplier',
        icon: icons.Truck,
        breadcrumbs: false
      },
      {
        id: 'other-expense',
        title: 'Other Expense',
        type: 'item',
        url: '/other-expense',
        icon: icons.Wallet,
        breadcrumbs: false
      }
    ]
  },
  {
    id: 'purchase',
    title: 'Purchase',
    type: 'item',
    url: '/purchase',
    icon: icons.Truck,
    breadcrumbs: false
  },
  {
    id: 'petty-cash',
    title: 'Petty Cash',
    type: 'item',
    url: '/petty-cash',
    icon: icons.Wallet,
    breadcrumbs: false
  },
  {
    id: 'invoice',
    title: 'Invoice',
    type: 'item',
    url: '/invoice',
    icon: icons.FileText,
    breadcrumbs: false
  }
];

const managerItems = [
  {
    id: 'users',
    title: 'Users',
    type: 'item',
    url: '/users',
    icon: icons.Users,
    breadcrumbs: false
  },
  {
    id: 'reports',
    title: 'Reports',
    type: 'collapse',
    icon: icons.PieChart,
    breadcrumbs: false,
    children: [
      {
        id: 'sales-report',
        title: 'Sales Report',
        type: 'item',
        url: '/sales-report',
        icon: icons.ShoppingCart,
        breadcrumbs: false
      },
      {
        id: 'purchase-report',
        title: 'Purchase Report',
        type: 'item',
        url: '/purchase-report',
        icon: icons.Truck,
        breadcrumbs: false
      },
      {
        id: 'ledger-report',
        title: 'Ledger Report',
        type: 'item',
        url: '/ledger-report',
        icon: icons.BookOpen,
        breadcrumbs: false
      }
    ]
  }
];

// const dashboard = {
//   id: 'group-dashboard',
//   title: 'Main Menu',
//   type: 'group',
//   children: [
//     {
//       id: 'dashboard',
//       title: 'Dashboard',
//       type: 'item',
//       url: '/dashboard/default',
//       icon: icons.LayoutDashboard,
//       breadcrumbs: false
//     },
//     {
//       id: 'assets',
//       title: 'Assets',
//       type: 'item',
//       url: '/assets',
//       icon: icons.PackageOpen,
//       breadcrumbs: false
//     },
//     {
//       id: 'users',
//       title: 'Users',
//       type: 'item',
//       url: '/users',
//       icon: icons.Users,
//       breadcrumbs: false
//     },
//     {
//       id: 'stocks',
//       title: 'Stocks',
//       type: 'item',
//       url: '/stocks',
//       icon: icons.Package,
//       breadcrumbs: false
//     },
//     {
//       id: 'party',
//       title: 'Party',
//       type: 'collapse',
//       icon: icons.Users,
//       breadcrumbs: false,
//       children: [
//         {
//           id: 'customer',
//           title: 'Customer',
//           type: 'item',
//           url: '/customer',
//           icon: icons.User,
//           breadcrumbs: false
//         },
//         {
//           id: 'supplier',
//           title: 'Supplier',
//           type: 'item',
//           url: '/supplier',
//           icon: icons.Truck,
//           breadcrumbs: false
//         },
//         {
//           id: 'other-expense',
//           title: 'Other Expense',
//           type: 'item',
//           url: '/other-expense',
//           icon: icons.Wallet,
//           breadcrumbs: false
//         }
//       ]
//     },
//     {
//       id: 'purchase',
//       title: 'Purchase',
//       type: 'item',
//       url: '/purchase',
//       icon: icons.Truck,
//       breadcrumbs: false
//     },
//     {
//       id: 'petty-cash',
//       title: 'Petty Cash',
//       type: 'item',
//       url: '/petty-cash',
//       icon: icons.Wallet,
//       breadcrumbs: false
//     },
//     {
//       id: 'invoice',
//       title: 'Invoice',
//       type: 'item',
//       url: '/invoice',
//       icon: icons.FileText,
//       breadcrumbs: false
//     },
//     {
//       id: 'reports',
//       title: 'Reports',
//       type: 'collapse',
//       icon: icons.PieChart,
//       breadcrumbs: false,
//       children: [
//         {
//           id: 'sales-report',
//           title: 'Sales Report',
//           type: 'item',
//           url: '/sales-report',
//           icon: icons.ShoppingCart,
//           breadcrumbs: false
//         },
//         {
//           id: 'purchase-report',
//           title: 'Purchase Report',
//           type: 'item',
//           url: '/purchase-report',
//           icon: icons.Truck,
//           breadcrumbs: false
//         },
//         {
//           id: 'ledger-report',
//           title: 'Ledger Report',
//           type: 'item',
//           url: '/ledger-report',
//           icon: icons.BookOpen,
//           breadcrumbs: false
//         }
//       ]
//     }
//   ]
// };

const dashboard = {
  id: 'group-dashboard',
  title: 'Main Menu',
  type: 'group',
  children: userData.isAdmin ? [...commonItems, ...managerItems] : commonItems
};

export default dashboard;
